import { Link } from "react-router-dom";

const LocationSecond = () => {
  return (
    <>
      <div className="inner-banner banner vd-banner">
        <div className="video-section">
          <div className=" videoPosition">
            <video autoPlay="" loop="" muted="muted" poster="images/hero-1.jpg">
              <source src="images/video/market-location.mp4" type="video/mp4" />
            </video>
            <video autoplay="" loop="" muted="muted" poster="images/hero-1.jpg">
              <source src="images/video/market-location.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
        <div className="container position-absolute">
          <div className="inner-banner-txt">
            <h1 className="banner-banner-heading text-white fs-60 heading">
              Welcome to Fashion Hub{" "}
            </h1>
            <h2 className="text-white fs-35  bg-site d-inline-block p-3">
              Nice to Meet You !
            </h2>
            <nav aria-label="breadcrumb" className="breadcrumb-nav">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  About Us{" "}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className="main-section abt-me">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-sm-4 col-xs-12">
              <div className="abt-me-box text-center">
                <span className="mbri-hearth" />
                <h3 className="fs-16 font-weight-normal">
                  CANADA BASED FASHION RETAILER
                </h3>
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-12">
              <div className="abt-me-box text-center">
                <span className="mbri-delivery" />
                <h3 className="fs-16 font-weight-normal">
                  NEW ARRIVALS WEEKLY
                </h3>
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-12">
              <div className="abt-me-box text-center">
                <span className="mbri-map-pin" />
                <h3 className="fs-16 font-weight-normal">OUR STORE </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="about-gallery">
        <div className="container">
          <div className="owner-box">
            <img src="images/about-me.jpg" alt="owner" />
            <div className="owner-txt text-white">
              <div className="founder-heading fs-45 text-white">Founders</div>
              <div className="fname">John Denny &amp; Rhena John</div>
            </div>
          </div>
        </div>
      </div>
      <div className="main-section store-gallery">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6 col-sm-6 col-xs-6 p-1">
              <div className="store-img object-fit">
                <img src="images/store-1.jpg" alt="Store" />
              </div>
            </div>
            {/* col */}
            <div className="col-lg-6 col-sm-6 col-xs-6 p-1">
              <div className="store-img object-fit">
                <img src="images/store-2.jpg" alt="Store" />
              </div>
            </div>
            {/* col */}
            <div className="col-lg-6 col-sm-6 col-xs-6 p-1">
              <div className="store-img object-fit">
                <img src="images/store-3.jpg" alt="Store" />
              </div>
            </div>
            {/* col */}
            <div className="col-lg-6 col-sm-6 col-xs-6 p-1">
              <div className="store-img object-fit">
                <img src="images/store-4.jpg" alt="Store" />
              </div>
            </div>
            {/* col */}
            <div className="col-lg-6 col-sm-6 col-xs-6 p-1">
              <div className="store-img object-fit">
                <img src="images/store-5.jpg" alt="Store" />
              </div>
            </div>
            {/* col */}
            <div className="col-lg-6 col-sm-6 col-xs-6 p-1">
              <div className="store-img object-fit">
                <img src="images/store-6.jpg" alt="Store" />
              </div>
            </div>
            {/* col */}
          </div>
        </div>
      </div>
      <div className="main-section customer-insta pt-0 border-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-sm-10 col-xs-12 m-auto">
              <div className="bg-site customer-insta-container">
                <h4 className="lobster text-white">Stay in the know!</h4>
                <div className="customer-slider owl-carousel">
                  <div className="item">
                    <div className="customer-box object-fit">
                      <a href="#">
                        <img src="images/whiteshut.jpg" alt="Our Customer" />
                        <div className="customer-post">
                          <p>
                            <small>
                              Lorem Ipsum is simply dummy text of the printing
                              and typesetting industry. @fashionHub #fashionHub
                              #model #fashion
                            </small>
                          </p>
                        </div>
                      </a>
                    </div>
                  </div>
                  {/* item */}
                  <div className="item">
                    <div className="customer-box object-fit">
                      <a href="#">
                        <img src="images/store-3.jpg" alt="Our Customer" />
                        <div className="customer-post">
                          <p>
                            <small>
                              Lorem Ipsum is simply dummy text of the printing
                              and typesetting industry. @fashionHub #fashionHub
                              #model #fashion
                            </small>
                          </p>
                        </div>
                      </a>
                    </div>
                  </div>
                  {/* item */}
                  <div className="item">
                    <div className="customer-box object-fit">
                      <a href="#">
                        <img src="images/store-4.jpg" alt="Our Customer" />
                        <div className="customer-post">
                          <p>
                            <small>
                              Lorem Ipsum is simply dummy text of the printing
                              and typesetting industry. @fashionHub #fashionHub
                              #model #fashion
                            </small>
                          </p>
                        </div>
                      </a>
                    </div>
                  </div>
                  {/* item */}
                  <div className="item">
                    <div className="customer-box object-fit">
                      <a href="#">
                        <img src="images/kasmiri.jpg" alt="Our Customer" />
                        <div className="customer-post">
                          <p>
                            <small>
                              Lorem Ipsum is simply dummy text of the printing
                              and typesetting industry. @fashionHub #fashionHub
                              #model #fashion
                            </small>
                          </p>
                        </div>
                      </a>
                    </div>
                  </div>
                  {/* item */}
                  <div className="item">
                    <div className="customer-box object-fit">
                      <a href="#">
                        <img src="images/fitness-2.jpg" alt="Our Customer" />
                        <div className="customer-post">
                          <p>
                            <small>
                              Lorem Ipsum is simply dummy text of the printing
                              and typesetting industry. @fashionHub #fashionHub
                              #model #fashion
                            </small>
                          </p>
                        </div>
                      </a>
                    </div>
                  </div>
                  {/* item */}
                </div>
                <p className="fs-20 text-white">
                  pint it . tag it, tweet it. <br />
                  #fashionHub for a chance to be featured!
                </p>
                <div className="stay-with border-top">
                  <p className="wow fadeInUp text-light">
                    <a href="#" className="text-light" target="blank">
                      @fashionHub
                    </a>{" "}
                    |{" "}
                    <a href="#" className="text-light" target="blank">
                      #fashionHub
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="main-section location-section border-top p-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-sm-3 col-xs-12 border-right">
              <div className="location-widget justify-content-center d-flex align-items-center h-100 pt-0">
                <div className="site-logo footer-logo">
                  <a href="index-3.html">fashion Hub</a>
                </div>
              </div>
            </div>
            {/* col */}
            <div className="col-lg-4 col-sm-4 col-xs-12 border-right">
              <div className="location-widget">
                <div className="location-header">
                  <h5 className="tcolor">MUMBAI</h5>
                  <a href="#">Directions</a>
                </div>
                <p className="wow fadeInUp">
                  31 Perry Cross Road, Near Otter's Club, Bandra West, Mumbai,
                  Maharashtra, 400050
                </p>
                <p className="wow fadeInUp">
                  <a href="tel:+91 9920 206 723">+91 9920 206 723</a>
                </p>
                <p className="wow fadeInUp">
                  Mon to Fri - 10 am to 4 pm <br />
                  <a href="emailto:contact.mumbai@fashion-hub.com">
                    contact.mumbai@fashion-hub.com
                  </a>
                </p>
              </div>
              <div className="location-widget pb-5">
                <div className="location-header">
                  <h5 className="tcolor">AHMEDABAD</h5>
                  <a href="#">Directions</a>
                </div>
                <p className="wow fadeInUp">
                  Near Kotak House, Behind Kensville Golf Academy, Bodakdev,
                  Ahmedabad, Gujarat, 380059
                </p>
                <p className="wow fadeInUp">
                  <a href="tel:+91 9920 206 723">+91 9920 206 723</a>
                </p>
                <p className="wow fadeInUp">
                  Mon to Fri - 10 am to 4 pm <br />
                  <a href="emailto:contact.mumbai@fashion-hub.com">
                    contact.mumbai@fashion-hub.com
                  </a>
                </p>
              </div>
            </div>
            {/* col */}
            <div className="col-lg-4 col-sm-4 col-xs-12">
              <div className="location-widget">
                <div className="location-header">
                  <h5 className="tcolor">HYDERABAD</h5>
                  <a href="#">Directions</a>
                </div>
                <p className="wow fadeInUp">
                  Lane next to HDFC Bank, Road Number 14, Venkat Nagar, Banjara
                  Hills, Hyderabad, Telangana, 500034
                </p>
                <p className="wow fadeInUp">
                  <a href="tel:+91 9920 206 723">+91 9920 206 723</a>
                </p>
                <p className="wow fadeInUp">
                  Mon to Fri - 10 am to 4 pm <br />
                  <a href="emailto:contact.mumbai@fashion-hub.com">
                    contact.mumbai@fashion-hub.com
                  </a>
                </p>
              </div>
              <div className="location-widget pb-5">
                <div className="location-header">
                  <h5 className="tcolor">JOBS</h5>
                </div>
                <p className="wow fadeInUp">
                  Visit
                  <a href="emailto:Careers@fashion-hub">Careers@fashion-hub</a>
                </p>
                <p className="wow fadeInUp">
                  or write in to us at
                  <a href="emailto:jobs@fashion-hub.com">
                    jobs@fashion-hub.com
                  </a>
                </p>
              </div>
            </div>
            {/* col */}
          </div>
        </div>
        <div className="copyright-section border-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-sm-4 col-xs-12 align-self-center">
                <div className="default-menu">
                  <ul className="list-style mb-0">
                    <li>
                      <a href="#">FAQ</a>
                    </li>
                    <li>
                      <a href="#">Privacy Policy</a>
                    </li>
                    <li>
                      <a href="#">Terms &amp; Conditions</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 col-sm-4 col-xs-12">
                <div className="social-icon">
                  <ul className="list-style text-center mb-0">
                    <li>
                      <a href="#">
                        <i className="fab fa-facebook-f" />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-instagram" />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-twitter" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 col-sm-4 col-xs-12 align-self-center">
                <p className="mb-0 text-right col-xs-text-center">
                  © 2019. All rights reserved
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LocationSecond;
